import { Directive, Input, computed, effect, signal } from '@angular/core';

import { IOutcome, IRacingPostForm } from '@frontend/oxygen/shared-utils';

import { LocaleService } from '../../../core/services/locale/locale.service';

@Directive({ standalone: true })
export class RunnerSpotlightTable {
    @Input() outcome: IOutcome;
    @Input() isUKorIRE: boolean;
    @Input() isGreyhoundEdp: boolean;
    forms: IRacingPostForm[];
    private outcomeSignal = signal<IOutcome | null>(null);
    formOutcomeOverview = computed(() => this.outcomeSignal()?.racingFormOutcome?.overview ?? '');

    constructor(protected locale: LocaleService) {
        effect(() => {
            if (this.outcome) {
                this.outcomeSignal.set(this.outcome);
            }
        });
    }

    trackByValue(i: number, form: IRacingPostForm): string {
        return form.date;
    }
}
